module.exports = __webpack_public_path__ + "img/fi-rr-align-center.067545bc.svg";